import { FunctionComponent as F, Fragment } from "react";
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import DateRangeIcon from '@mui/icons-material/DateRange';
import TextTooltip from "../UI/Tooltip/TextTooltip";


interface IProps
{
  headings: { Header: string, accessor: string }[];
  checked: boolean;
  handleCheck: () => void
}

const MmProtocolTableHeader: F<IProps> = props =>
{
  return (
    <TableHead key='Header'>
      <TableRow key='Header' style={{ alignItems: 'center' }}>
        {props.headings.map((heading, index) =>
        {
          let textAlign = 'left';
          let displayHeader = <b>{heading.Header}</b>;
          let paddingLeft = '10px';

          switch(heading.accessor)
          {
          case "suppName":
            displayHeader = <b>{heading.Header + " "}</b>;
            break;
          case "dose":
            break;
          case "dosesPerDay":
            textAlign = 'center';
            displayHeader = (
              <TextTooltip lines={[heading.Header]}>
                <MoreTimeIcon/>
              </TextTooltip>);
            break;
          case "daysPerMonth":
            textAlign = 'center';
            displayHeader = (
              <TextTooltip lines={[heading.Header]}>
                <DateRangeIcon/>
              </TextTooltip>);
            break;
          case "doseUnit":
          case "checked":
            textAlign = 'center';
            paddingLeft = '0px';
          }

          return (
            <TableCell
              key={index}
              align={textAlign as "inherit" | "left" | "center" | "right" | "justify" | undefined}
              style={{ paddingLeft, paddingRight: "10px" }}>
              {heading.accessor === 'checked' ?
                <Checkbox checked={props.checked} onChange={props.handleCheck}/> :
                displayHeader}
            </TableCell>);
        })}
      </TableRow>
    </TableHead>);
};

export default MmProtocolTableHeader;
